module.exports = __webpack_public_path__ + "static/media/calenderIcon.c2e7d52f.svg";